<div id="page-view__container" class="page-view__container" [class.multi-q]="page().visibleQuestions.length > 1">
  @for (question of page().visibleQuestions; track question.id) {
    @if (question.optionsSettings?.autopopulateInd && question.visibleOptions.length === 1 && question.requiredInd) {
      @if (questionCtrls()[question.id].dirty) {
        <ng-container *ngTemplateOutlet="questionView; context: { question: question }"></ng-container>
      }
    } @else {
      <ng-container *ngTemplateOutlet="questionView; context: { question: question }"></ng-container>
    }
  }
</div>

<ng-template #questionView let-question="question">
  <empathy-question-view
    slot="details"
    [question]="question"
    [questionCtrl]="questionCtrls()[question.id]"
    (forceStop)="forceStop$.set($event)"
    (httpError)="httpError.emit()"
  ></empathy-question-view>
</ng-template>

<div @showFooter class="survey-viewer__footer">
  <empathy-viewer-progress-bar [progress]="progress()"></empathy-viewer-progress-bar>
  <mat-toolbar class="survey-viewer__footer__toolbar">
    @if (shouldShowBackButton$()) {
      <empathy-viewer-button [tooltip]="'Previous question'" [icon]="faArrowLeft" [background]="'transparent'" (clicked)="onPrev()"></empathy-viewer-button>
    }

    @if (showCompleteButton()) {
      <empathy-viewer-button
        [text]="nextButtonText$()"
        [icon]="faArrowRight"
        [iconPosition]="'right'"
        [disabled]="notAllCtrlsValid$() || submitting() || forceStop$() || hasErrors$() || !surveyViewerStateService.canProceed$()"
        [loading]="submitting()"
        [loadingText]="'Sending...'"
        (clicked)="onNext()"
      ></empathy-viewer-button>
    } @else {
      <empathy-viewer-button
        [text]="nextButtonText$()"
        [icon]="faArrowRight"
        [iconPosition]="'right'"
        [disabled]="notAllCtrlsValid$() || isSaving() || forceStop$() || hasErrors$() || !surveyViewerStateService.canProceed$()"
        [loading]="isSaving()"
        [loadingText]="'Saving...'"
        (clicked)="onNext()"
      ></empathy-viewer-button>
    }
  </mat-toolbar>
</div>
